import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-8 pb-4 px-4 bg-white text-center" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-125">
          <span className="px-2 text-[#F9327E] bg-[#FFFFFF] text-[24px]" data-id="element-126">
            PACK EFEMÉRIDES LISTAS
          </span>
        </h1>

        <h2 className="md:text-2xl font-extrabold mb-3 text-gray-800 text-[16px]" data-id="element-127">
          El pack docente que te resuelve todas las efemérides del año en
          minutos
        </h2>

        <a href="#compra" className="block max-w-[280px] mx-auto mb-3 cursor-pointer hover:opacity-95 transition-opacity" data-id="element-128">
          <img src="https://cdn.magicpatterns.com/uploads/anbkPXfQGWewVMjCirizg3/MOCKAP_PRINCIPAL.png" alt="Pack Efemérides Listas" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-129" />
        </a>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-130">
          <p className="text-[14px]" data-id="element-131">
            No pierdas tiempo buscando efemérides, actividades y discursos. Con
            este pack vas a tener todo organizado, listo para usar y preparado
            para cada fecha del calendario escolar.
          </p>
        </div>
      </div>
    </section>;
}